(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[14551],{

/***/ 558982:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phongvu/desktop/products/detail/[productId]",
      function () {
        return __webpack_require__(869506);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 869506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ detail_productId_; }
});

// EXTERNAL MODULE: ./tenants/phongvu/desktop/products/[sku].tsx
var _sku_ = __webpack_require__(945656);
;// CONCATENATED MODULE: ./tenants/phongvu/desktop/products/detail/[productId].tsx

/* harmony default export */ var _productId_ = (_sku_/* default */.Z);
const getServerSideProps = (/* unused pure expression or super */ null && (getServerSidePropsDetail));

;// CONCATENATED MODULE: ./pages/phongvu/desktop/products/detail/[productId].tsx
// AUTO GENERATED FILE. DO NOT EDIT.

var __N_SSP = true;
/* harmony default export */ var detail_productId_ = (_productId_);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [41305,19303,90400,29078,4545,66756,3377,88837,22859,60085,55890,6174,55530,93712,49774,92888,40179], function() { return __webpack_exec__(558982); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);